import React, { useState } from 'react';
import { downloadFolderAsZip } from './downloadZip';

const DownloadButton = ({ folderPath }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    await downloadFolderAsZip(folderPath);
    setIsDownloading(false);
  };

  return (
    <button onClick={handleDownload} disabled={isDownloading}>
      {isDownloading ? 'Downloading...' : 'Download Folder'}
    </button>
  );
};

export default DownloadButton;
